import { Injectable } from '@angular/core';
import { SplHttpBaseService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class SplHttpUsersService extends SplHttpBaseService {}
